{
  "version": "1.0",
  "chart": "bar-column",
  "// about": "Self-contained config for the unified Bar & Column chart family. The DVM Layout Builder loads the shell (dvm-layout-builder.json) and deep-merges every chart file listed in the shell's `chartConfigs` into it. `layoutSteps` are merged by key; `options` are merged per-key (objects deep, arrays concatenated). Nothing here is duplicated in the shell — this is the single home for Bar & Column behaviour, variants, ECharts defaults, and format controls.",

  "layoutSteps": {
    "BAR": {
      "label": "Bar & column",
      "sections": [
        {
          "id": "config",
          "title": "Chart configuration",
          "fields": [
            { "field": "layoutType", "label": "Chart layout", "control": "select", "optionsKey": "layoutTypes", "required": true },
            { "field": "title", "label": "Title", "control": "text", "required": true },
            { "field": "dataset", "label": "Dataset", "control": "select", "required": true }
          ]
        },
        {
          "id": "bar",
          "title": "Bar & column",
          "fields": [
            { "field": "orientation", "label": "Orientation", "control": "toggle" },
            { "field": "variant", "label": "Variant", "control": "select", "optionsKey": "barVariants", "required": true },
            { "field": "category", "label": "Category (group by)", "control": "select", "required": true },
            { "field": "categoryLabel", "label": "Category axis label", "control": "text" },
            { "field": "xAxisFontWeight", "label": "X axis label weight", "control": "select", "optionsKey": "fontWeights" },
            { "field": "yAxisFontWeight", "label": "Y axis label weight", "control": "select", "optionsKey": "fontWeights" },
            { "field": "axis2FontWeight", "label": "Secondary axis label weight", "control": "select", "optionsKey": "fontWeights" },
            { "field": "series", "label": "Split into series (optional)", "control": "select" },
            { "field": "measures", "label": "Measures", "control": "select", "repeatable": true, "required": true },
            { "field": "valueFormula", "label": "Value formula (computed)", "control": "text", "hint": "Backend-computed value, so it can reference a live input via [Token]. Supports per-group overrides. Leave blank to just aggregate the Measures." },
            { "field": "renderAs", "label": "Draw as", "control": "select", "optionsKey": "barRenderTypes", "repeatable": true },
            { "field": "axis", "label": "Axis", "control": "select", "optionsKey": "barAxisOptions", "repeatable": true }
          ]
        }
      ]
    }
  },

  "options": {
    "// barVariants": "Each entry is FULLY config-driven — behaviour flags: `usesSeries`=offers a Split column; `seriesFromMeasures`=the series/legend may instead come from SEVERAL MEASURES (so a series can be a formula/computed column), which makes Split optional and shows 'Add measure'; `needsTwoMeasures`=needs Primary+Comparison; `hint`=picker guidance. RENDER-dispatch flags (drive the option builder, no variant-name checks in code): `stack`=stacked bars; `normalize100`=normalise each category to 100%; `comparison`=Primary-vs-Comparison renderer. Adding a new variant here needs NO code change.",
    "barVariants": [
      { "label": "Simple Bar", "value": "simple", "usesSeries": false, "allowMultipleMeasures": true },
      { "label": "Grouped Bar", "value": "grouped", "usesSeries": true, "seriesFromMeasures": true, "hint": "Split by a column, OR leave Split empty and add one measure per series (each can be a formula)." },
      { "label": "Stacked Bar", "value": "stacked", "usesSeries": true, "seriesFromMeasures": true, "stack": true, "hint": "Split by a column, OR leave Split empty and add one measure per stack segment (each can be a formula)." },
      { "label": "100% Stacked Bar", "value": "stacked-100", "usesSeries": true, "seriesFromMeasures": true, "stack": true, "normalize100": true, "hint": "Split by a column, OR leave Split empty and add one measure per stack segment (each can be a formula)." },
      { "label": "Clustered Bar Chart", "value": "clustered", "usesSeries": true, "seriesFromMeasures": true, "hint": "Split by a column, OR leave Split empty and add one measure per cluster member (each can be a formula)." },
      { "label": "Comparison Bar (A vs B)", "value": "comparison", "usesSeries": false, "needsTwoMeasures": true, "comparison": true }
    ],
    "barRenderTypes": [
      { "label": "Bar", "value": "bar" },
      { "label": "Line", "value": "line" },
      { "label": "Area", "value": "area" }
    ],
    "barAxisOptions": [
      { "label": "Primary axis", "value": "y1" },
      { "label": "Secondary axis (dual)", "value": "y2" }
    ],
    "// axisLabels": "Orientation-aware mapping labels for the Bar builder (X/Y ↔ category/values). Fully config-driven.",
    "axisLabels": {
      "categoryVertical": "X-axis",
      "categoryHorizontal": "Y-axis",
      "valueVertical": "Y-axis ",
      "valueHorizontal": "X-axis "
    },
    "// formatGroupOrder": "Order of the Format accordion sections. Unknown groups are appended after these.",
    "formatGroupOrder": ["Title", "Axis", "Legend", "Labels", "Tooltip", "Formatting", "Interaction", "Advanced"],
    "// barChartDefaults": "ALL ECharts styling + layout constants for the unified bar-column chart — every value config-driven so NOTHING is baked into code. `layout` holds pixel spacing; `refLineStyle`/varianceLabelColor/tooltip control fine styling.",
    "barChartDefaults": {
      "palette": ["#1f6feb", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4", "#ec4899", "#84cc16"],
      "barWidthPercent": 60,
      "valueAxisTicks": 4,
      "labelMinMargin": 4,
      "categoryLabelWidthVertical": 84,
      "categoryLabelWidthHorizontal": 96,
      "referenceLineColor": "#64748b",
      "referenceLineStyle": "dashed",
      "varianceUpColor": "#10b981",
      "varianceDownColor": "#ef4444",
      "varianceLabelColor": "#334155",
      "rotateThreshold": 6,
      "labelPositionVertical": "top",
      "labelPositionHorizontal": "right",
      "layout": {
        "gridLeft": 12,
        "gridRightBase": 16,
        "gridRightLegend": 72,
        "gridTopBase": 28,
        "gridTopLegend": 36,
        "gridBottomBase": 16,
        "gridBottomLegend": 30,
        "gridBottomAxisName": 30,
        "gridHierarchyBottom": 24,
        "gridHierarchyLeft": 40,
        "categoryNameGapVertical": 30,
        "categoryNameGapHorizontalOffset": 18,
        "categoryNamePaddingTop": 8,
        "valueNameGapVertical": 50,
        "valueNameGapHorizontal": 34,
        "zoomSliderPadding": 30,
        "legendRightOffset": 4
      },
      "tooltip": {
        "seriesColorFallback": "#1f6feb",
        "trackBg": "rgba(148,163,184,.25)",
        "minWidth": 180,
        "labelWidth": 70,
        "barMinWidth": 60,
        "barHeight": 8
      }
    },

    "// bar option lists": "Dropdown lists referenced ONLY by the Bar chart's formatControls below.",
    "labelRotations": [
      { "label": "Auto", "value": "auto" },
      { "label": "0°", "value": "0" },
      { "label": "30°", "value": "30" },
      { "label": "45°", "value": "45" },
      { "label": "90°", "value": "90" }
    ],
    "legendPositions": [
      { "label": "Bottom", "value": "bottom" },
      { "label": "Top", "value": "top" },
      { "label": "Right", "value": "right" },
      { "label": "Hidden", "value": "none" }
    ],
    "tooltipTriggers": [
      { "label": "On hover (axis)", "value": "axis" },
      { "label": "On item", "value": "item" },
      { "label": "Off", "value": "none" }
    ],
    "tooltipPositions": [
      { "label": "Auto", "value": "auto" },
      { "label": "Top", "value": "top" },
      { "label": "Bottom", "value": "bottom" },
      { "label": "Left", "value": "left" },
      { "label": "Right", "value": "right" },
      { "label": "Fixed (top-right)", "value": "fixed-tr" }
    ],
    "axisPointerStyles": [
      { "label": "None", "value": "none" },
      { "label": "Vertical line", "value": "line" },
      { "label": "Crosshair", "value": "cross" },
      { "label": "Shadow band", "value": "shadow" }
    ],
    "palettes": [
      { "key": "default", "label": "Default", "colors": ["#1f6feb", "#0f9f8f", "#8657d6", "#f59e0b", "#ef4444", "#10b981", "#3b82f6", "#ec4899"] },
      { "key": "warm", "label": "Warm", "colors": ["#ef4444", "#f97316", "#f59e0b", "#eab308", "#dc2626", "#b45309", "#9333ea", "#c026d3"] },
      { "key": "cool", "label": "Cool", "colors": ["#0ea5e9", "#06b6d4", "#0891b2", "#0284c7", "#2563eb", "#1d4ed8", "#4f46e5", "#7c3aed"] },
      { "key": "vibrant", "label": "Vibrant", "colors": ["#ec4899", "#06b6d4", "#10b981", "#f59e0b", "#8b5cf6", "#ef4444", "#0ea5e9", "#84cc16"] },
      { "key": "monochrome", "label": "Monochrome", "colors": ["#1e293b", "#334155", "#475569", "#64748b", "#94a3b8", "#cbd5e1", "#0f172a", "#020617"] }
    ],
    "paletteOptions": [
      { "label": "Default", "value": "default" },
      { "label": "Warm", "value": "warm" },
      { "label": "Cool", "value": "cool" },
      { "label": "Vibrant", "value": "vibrant" },
      { "label": "Monochrome", "value": "monochrome" }
    ],
    "labelModes": [
      { "label": "Value", "value": "value" },
      { "label": "Percent", "value": "percent" },
      { "label": "Name + Value", "value": "name-value" },
      { "label": "Name + Percent", "value": "name-percent" }
    ],
    "numberScales": [
      { "label": "None", "value": "none" },
      { "label": "Auto (K/M/B)", "value": "compact" },
      { "label": "Thousands (K)", "value": "thousands" },
      { "label": "Millions (M)", "value": "millions" },
      { "label": "Billions (B)", "value": "billions" }
    ],
    "sortDirections": [
      { "label": "None (source order)", "value": "none" },
      { "label": "Ascending", "value": "asc" },
      { "label": "Descending", "value": "desc" }
    ],
    "zoomAxes": [
      { "label": "Category axis", "value": "category" },
      { "label": "Value axis", "value": "value" },
      { "label": "Both axes", "value": "both" }
    ],

    "// formatControls": "The Bar chart's own Format-popup / build-form controls (all `appliesTo:[\"BAR\"]`). Merged (concatenated) into the shell's shared formatControls. `group` places a control in an accordion section (Title/Axis/Legend/Labels/Tooltip/Formatting/Interaction/Advanced).",
    "formatControls": [
      { "key": "tooltipEnabled", "label": "Show tooltip", "control": "toggle", "default": true, "enabled": true, "group": "Tooltip", "appliesTo": ["BAR"] },
      { "key": "tooltipTrigger", "label": "Trigger", "control": "select", "optionsKey": "tooltipTriggers", "default": "axis", "enabled": true, "group": "Tooltip", "appliesTo": ["BAR"] },
      { "key": "tooltipPosition", "label": "Position", "control": "select", "optionsKey": "tooltipPositions", "default": "auto", "enabled": true, "group": "Tooltip", "appliesTo": ["BAR"] },
      { "key": "tooltipShowChart", "label": "Show mini chart in tooltip", "control": "toggle", "default": false, "enabled": true, "group": "Tooltip", "appliesTo": ["BAR"] },
      { "key": "tooltipAxisPointer", "label": "Axis pointer", "control": "select", "optionsKey": "axisPointerStyles", "default": "shadow", "enabled": true, "group": "Tooltip", "appliesTo": ["BAR"] },
      { "key": "tooltipBackground", "label": "Background", "control": "color", "default": "#1e293b", "enabled": true, "group": "Tooltip", "appliesTo": ["BAR"] },
      { "key": "tooltipTextColor", "label": "Text color", "control": "color", "default": "#f8fafc", "enabled": true, "group": "Tooltip", "appliesTo": ["BAR"] },
      { "key": "tooltipBorderColor", "label": "Border color", "control": "color", "default": "#334155", "enabled": true, "group": "Tooltip", "appliesTo": ["BAR"] },
      { "key": "tooltipBorderRadius", "label": "Corner radius", "control": "number", "default": 6, "min": 0, "max": 24, "step": 1, "enabled": true, "group": "Tooltip", "appliesTo": ["BAR"] },
      { "key": "tooltipFontSize", "label": "Font size", "control": "number", "default": 12, "min": 9, "max": 20, "step": 1, "enabled": true, "group": "Tooltip", "appliesTo": ["BAR"] },

      { "key": "xAxisLabel", "label": "X-axis title", "control": "text", "enabled": true, "group": "Axis", "appliesTo": ["BAR"] },
      { "key": "yAxisLabel", "label": "Y-axis title", "control": "text", "enabled": true, "group": "Axis", "appliesTo": ["BAR"] },
      { "key": "xAxisLabel2", "label": "Secondary X-axis title", "control": "text", "enabled": true, "group": "Axis", "appliesTo": ["BAR"] },
      { "key": "yAxisLabel2", "label": "Secondary Y-axis title", "control": "text", "enabled": true, "group": "Axis", "appliesTo": ["BAR"] },
      { "key": "axisLabelRotation", "label": "Category label angle", "control": "select", "optionsKey": "labelRotations", "default": "auto", "enabled": true, "group": "Axis", "appliesTo": ["BAR"] },
      { "key": "showGridLines", "label": "Show grid lines", "control": "toggle", "default": true, "enabled": true, "group": "Axis", "appliesTo": ["BAR"] },

      { "key": "showLegend", "label": "Show legend", "control": "toggle", "default": true, "enabled": true, "group": "Legend", "appliesTo": ["BAR"] },
      { "key": "legendPosition", "label": "Legend position", "control": "select", "optionsKey": "legendPositions", "default": "bottom", "enabled": true, "group": "Legend", "appliesTo": ["BAR"] },

      { "key": "labelMode", "label": "Data label mode", "control": "select", "optionsKey": "labelModes", "default": "value", "enabled": true, "group": "Labels", "appliesTo": ["BAR"] },

      { "key": "palette", "label": "Color palette", "control": "select", "optionsKey": "paletteOptions", "default": "default", "enabled": true, "group": "Formatting", "appliesTo": ["BAR"] },
      { "key": "numberScale", "label": "Number scale", "control": "select", "optionsKey": "numberScales", "default": "none", "enabled": true, "group": "Formatting", "appliesTo": ["BAR"] },
      { "key": "decimals", "label": "Decimal places (round off)", "control": "number", "default": 1, "min": 0, "max": 6, "step": 1, "enabled": true, "group": "Formatting", "appliesTo": ["BAR"] },
      { "key": "xAxisPrefix", "label": "X-axis prefix", "placeholder": "e.g. $", "width": "half", "control": "text", "default": "", "enabled": true, "group": "Formatting", "appliesTo": ["BAR"] },
      { "key": "xAxisSuffix", "label": "X-axis suffix", "placeholder": "e.g. %", "width": "half", "control": "text", "default": "", "enabled": true, "group": "Formatting", "appliesTo": ["BAR"] },
      { "key": "yAxisPrefix", "label": "Y-axis prefix", "placeholder": "e.g. $", "width": "half", "control": "text", "default": "", "enabled": true, "group": "Formatting", "appliesTo": ["BAR"] },
      { "key": "yAxisSuffix", "label": "Y-axis suffix", "placeholder": "e.g. %", "width": "half", "control": "text", "default": "", "enabled": true, "group": "Formatting", "appliesTo": ["BAR"] },

      { "key": "barWidthPercent", "label": "Bar width %", "control": "number", "default": 60, "min": 10, "max": 100, "step": 5, "enabled": true, "group": "Advanced", "appliesTo": ["BAR"] },
      { "key": "barCategoryGapPercent", "label": "Category gap %", "control": "number", "default": 20, "min": 0, "max": 90, "step": 5, "enabled": true, "group": "Advanced", "appliesTo": ["BAR"] },
      { "key": "barGapPercent", "label": "Series gap %", "control": "number", "default": 30, "min": 0, "max": 100, "step": 5, "enabled": true, "group": "Advanced", "appliesTo": ["BAR"] },
      { "key": "barCornerRadius", "label": "Corner radius (px)", "control": "number", "default": 0, "min": 0, "max": 20, "step": 1, "enabled": true, "group": "Advanced", "appliesTo": ["BAR"] },
      { "key": "sortBy", "label": "Sort by value", "control": "select", "optionsKey": "sortDirections", "default": "none", "enabled": true, "group": "Advanced", "appliesTo": ["BAR"] },
      { "key": "topN", "label": "Top N categories (0 = all)", "control": "number", "default": 0, "min": 0, "max": 100, "step": 1, "enabled": false, "group": "Advanced", "appliesTo": ["BAR"] },
      { "key": "valueAxisMin", "label": "Value axis min (blank = auto)", "control": "number", "enabled": false, "group": "Advanced", "appliesTo": ["BAR"] },
      { "key": "valueAxisMax", "label": "Value axis max (blank = auto)", "control": "number", "enabled": false, "group": "Advanced", "appliesTo": ["BAR"] },
      { "key": "valueAxisLog", "label": "Log scale (value axis)", "control": "toggle", "default": false, "enabled": false, "group": "Advanced", "appliesTo": ["BAR"] },
      { "key": "showStackTotals", "label": "Show stack totals", "control": "toggle", "default": false, "enabled": false, "group": "Advanced", "appliesTo": ["BAR"] },
      { "key": "animation", "label": "Animation", "control": "toggle", "default": true, "enabled": false, "group": "Advanced", "appliesTo": ["BAR"] },
      { "key": "smoothLines", "label": "Smooth line series", "control": "toggle", "default": false, "enabled": false, "group": "Advanced", "appliesTo": ["BAR"] },
      { "key": "showVariance", "label": "Show variance % (Comparison)", "control": "toggle", "default": true, "enabled": false, "group": "Advanced", "appliesTo": ["BAR"] },
      { "key": "varianceUpColor", "label": "Variance up color", "control": "color", "default": "#10b981", "enabled": false, "group": "Advanced", "appliesTo": ["BAR"] },
      { "key": "varianceDownColor", "label": "Variance down color", "control": "color", "default": "#ef4444", "enabled": false, "group": "Advanced", "appliesTo": ["BAR"] },

      { "key": "enableZoom", "label": "Enable zoom / pan", "control": "toggle", "default": false, "enabled": true, "group": "Interaction", "appliesTo": ["BAR"] },
      { "key": "zoomAxis", "label": "Zoom axis", "control": "select", "optionsKey": "zoomAxes", "default": "category", "enabled": true, "group": "Interaction", "appliesTo": ["BAR"] },
      { "key": "showZoomSlider", "label": "Show zoom slider", "control": "toggle", "default": true, "enabled": true, "group": "Interaction", "appliesTo": ["BAR"] },
      { "key": "highlightOnClick", "label": "Highlight bar on click", "control": "toggle", "default": false, "enabled": true, "group": "Interaction", "appliesTo": ["BAR"] },
      { "key": "crossFilter", "label": "Publish cross-filter on click", "control": "toggle", "default": false, "enabled": true, "group": "Interaction", "appliesTo": ["BAR"] }
    ]
  }
}
